module.exports = __webpack_public_path__ + "static/media/blueitem1.69eb65f5.png";